import script from "./AccessAsPointerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessAsPointerCard.vue?vue&type=script&setup=true&lang=ts"

import "./AccessAsPointerCard.vue?vue&type=style&index=0&id=cd3a1caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3a1caa"]])

export default __exports__